import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import { GOOGLE, REVIEWS } from "../lib/prestations";
import Reveal from "./Reveal";

function GoogleG({ className = "h-5 w-5" }) {
  return (
    <svg className={className} viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
  );
}

function Stars({ n = 5, className = "h-4 w-4" }) {
  return (
    <div className="flex gap-0.5 text-amber-400">
      {Array.from({ length: n }).map((_, i) => (
        <Star key={i} className={`${className} fill-amber-400`} />
      ))}
    </div>
  );
}

// reviews: optional array. If omitted, uses all categories combined.
export default function GoogleReviews({ reviews, title = "Ce que disent nos clients", subtitle }) {
  const list =
    reviews || [...REVIEWS.plomberie, ...REVIEWS.serrurerie, ...REVIEWS.electricite];

  return (
    <section data-testid="google-reviews" className="bg-white py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="rounded-[1.75rem] border border-slate-200 bg-slate-50 p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-center gap-5 md:gap-8 mb-10 text-center md:text-left">
            <GoogleG className="h-10 w-10 shrink-0 mx-auto md:mx-0" />
            <div>
              <div className="flex items-center justify-center md:justify-start gap-3">
                <span className="font-display font-extrabold text-3xl text-ink">{GOOGLE.rating.toFixed(1)}</span>
                <Stars className="h-5 w-5" />
              </div>
              <p className="text-ink-soft text-sm mt-1">
                Note moyenne sur <span className="font-semibold text-ink">{GOOGLE.count.toLocaleString("fr-FR")} avis Google</span>
              </p>
            </div>
          </div>
        </Reveal>

        {(title || subtitle) && (
          <div className="text-center max-w-2xl mx-auto mb-8">
            {title && <h2 className="font-display font-extrabold text-ink text-2xl md:text-4xl">{title}</h2>}
            {subtitle && <p className="text-ink-soft mt-3">{subtitle}</p>}
          </div>
        )}
      </div>

      <Marquee speed={40} gradient gradientColor="#ffffff" gradientWidth={60} pauseOnHover autoFill>
        {list.map((r, i) => (
          <div
            key={i}
            data-testid="review-card"
            className="w-[320px] md:w-[380px] mx-3 card-soft p-6 hover:translate-y-0 whitespace-normal"
          >
            <div className="flex items-center justify-between mb-3">
              <Stars />
              <GoogleG className="h-4 w-4" />
            </div>
            <p className="text-ink leading-relaxed">&ldquo;{r.text}&rdquo;</p>
            <div className="mt-4 pt-3 border-t border-slate-100 flex items-center gap-3">
              <span className="h-9 w-9 rounded-full bg-brand/10 text-brand font-bold flex items-center justify-center">
                {r.name.charAt(0)}
              </span>
              <div>
                <p className="font-semibold text-ink text-sm leading-none">{r.name}</p>
                <p className="text-ink-muted text-xs mt-1">{r.city}</p>
              </div>
            </div>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
